import React from "react";
import { MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";

const FONT = "'Host Grotesk', sans-serif";

const periods = [
  { value: "12h", label: "Last 12 Hours" },
  { value: "24h", label: "Last 24 Hours" },
  { value: "7d",  label: "Last 7 Days"   },
  { value: "30d", label: "Last 1 Month"  },
];

const DateWiseDropdown = ({ activeBtn, handleDateWiseAPI }) => {
  const selected = periods.find((p) => p.value === activeBtn);

  return (
    <FormControl sx={{ width: "100%" }} size="small">
      <InputLabel
        id="datewise-dropdown-label"
        shrink
        sx={{
          fontFamily: FONT,
          fontSize: "13px",
          color: "#94a3b8",
          "&.Mui-focused": { color: "#6366f1" },
        }}
      >
        Time Period
      </InputLabel>
      <Select
        labelId="datewise-dropdown-label"
        value={activeBtn}
        onChange={(e) => handleDateWiseAPI(e.target.value)}
        displayEmpty
        label="Time Period"
        renderValue={() => (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <FontAwesomeIcon
              icon={faClock}
              style={{ fontSize: "12px", color: "#6366f1" }}
            />
            <span style={{ fontFamily: FONT, fontSize: "13px", color: "#1e293b" }}>
              {selected?.label ?? "Select Period"}
            </span>
          </div>
        )}
        sx={{
          height: "44px",
          borderRadius: "10px",
          fontFamily: FONT,
          fontSize: "13px",
          backgroundColor: "#ffffff",
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#a5b4fc",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#6366f1",
            borderWidth: "1.5px",
          },
        }}
        MenuProps={{
          PaperProps: {
            style: {
              borderRadius: "12px",
              boxShadow: "0 8px 30px rgba(0,0,0,0.10)",
              border: "1px solid #e2e8f0",
              marginTop: "4px",
              fontFamily: FONT,
            },
          },
        }}
      >
        {periods.map(({ value, label }) => {
          const isSelected = activeBtn === value;
          return (
            <MenuItem
              key={value}
              value={value}
              sx={{
                fontFamily: FONT,
                fontSize: "13px",
                fontWeight: isSelected ? 600 : 400,
                borderRadius: "8px",
                mx: "4px",
                my: "2px",
                gap: "10px",
                color: isSelected ? "#6366f1" : "#374151",
                backgroundColor: isSelected ? "#eef2ff" : "transparent",
                "&:hover": {
                  backgroundColor: "#eef2ff",
                  color: "#6366f1",
                },
              }}
            >
              <FontAwesomeIcon
                icon={faClock}
                style={{
                  fontSize: "12px",
                  color: isSelected ? "#6366f1" : "#94a3b8",
                }}
              />
              {label}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default DateWiseDropdown;